// 인증 컨텍스트 - 로그인 상태 관리
import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from '../firebase';
import {
  signInWithPopup,
  signInWithCredential,
  GoogleAuthProvider,
  signOut,
  onAuthStateChanged
} from 'firebase/auth';
import { Capacitor } from '@capacitor/core';
import { FirebaseAuthentication } from '@capacitor-firebase/authentication';

const AuthContext = createContext();

// 관리자 이메일 목록 (여기에 본인 구글 이메일 추가)
const ADMIN_EMAILS = [
  'hehihoho86@gmail.com', // 본인 이메일로 변경하세요
];

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  // 구글 로그인 (웹/모바일 분기 처리)
  const loginWithGoogle = async () => {
    try {
      const platform = Capacitor.getPlatform();

      // 모바일 환경 (Android/iOS)
      if (platform === 'android' || platform === 'ios') {
        // Capacitor Firebase Authentication 사용
        const result = await FirebaseAuthentication.signInWithGoogle();

        // Firebase Auth credential 생성
        const credential = GoogleAuthProvider.credential(
          result.credential?.idToken,
          result.credential?.accessToken
        );

        // Firebase Auth에 로그인
        const userCredential = await signInWithCredential(auth, credential);
        return userCredential.user;
      }
      // 웹 환경
      else {
        const provider = new GoogleAuthProvider();
        const result = await signInWithPopup(auth, provider);
        return result.user;
      }
    } catch (error) {
      console.error('로그인 실패:', error);
      throw error;
    }
  };

  // 로그아웃
  const logout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error('로그아웃 실패:', error);
      throw error;
    }
  };

  // 인증 상태 변경 감지
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);

      // 관리자 권한 체크
      if (user && ADMIN_EMAILS.includes(user.email)) {
        setIsAdmin(true);
      } else {
        setIsAdmin(false);
      }

      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    isAdmin,
    loginWithGoogle,
    logout,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
